import React, { useState, useEffect } from 'react';
import { db, handleFirestoreError, OperationType } from '../src/firebase';
import { doc, getDoc, setDoc, collection, getDocs } from 'firebase/firestore';
import { DEDUCTOR_DATA } from '../constants/deductorData';
import { Save, Loader2 } from 'lucide-react';

export const DeductorManagement: React.FC = () => {
  const [deductors, setDeductors] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchDeductors();
  }, []);

  const fetchDeductors = async () => {
    setLoading(true);
    try {
      const querySnapshot = await getDocs(collection(db, 'deductor'));
      const data: Record<string, any> = {};
      querySnapshot.forEach((doc) => {
        data[doc.id] = doc.data();
      });
      
      // If empty, initialize from constants
      if (Object.keys(data).length === 0) {
        for (const [district, info] of Object.entries(DEDUCTOR_DATA)) {
          data[district] = info;
          await setDoc(doc(db, 'deductor', district), info);
        }
      }
      setDeductors(data);
    } catch (error) {
      handleFirestoreError(error, OperationType.LIST, 'deductor');
    } finally {
      setLoading(false);
    }
  };

  const updateDeductor = async (district: string, field: string, value: string) => {
    setDeductors(prev => ({
      ...prev,
      [district]: { ...prev[district], [field]: value }
    }));
  };

  const saveDeductor = async (district: string) => {
    setSaving(true);
    try {
      await setDoc(doc(db, 'deductor', district), deductors[district]);
      alert('Saved successfully!');
    } catch (error) {
      handleFirestoreError(error, OperationType.WRITE, `deductor/${district}`);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="flex justify-center p-10"><Loader2 className="animate-spin" /></div>;

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-black text-slate-900">Manage Deductor Data</h2>
      <div className="grid grid-cols-1 gap-4">
        {Object.entries(deductors).map(([district, info]) => (
          <div key={district} className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm space-y-2">
            <h3 className="font-bold text-lg text-orange-600">{district}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input value={info.address || ''} onChange={(e) => updateDeductor(district, 'address', e.target.value)} className="p-2 border rounded" placeholder="Address" />
              <input value={info.pan || ''} onChange={(e) => updateDeductor(district, 'pan', e.target.value)} className="p-2 border rounded" placeholder="PAN" />
              <input value={info.tan || ''} onChange={(e) => updateDeductor(district, 'tan', e.target.value)} className="p-2 border rounded" placeholder="TAN" />
              <input value={info.dpoName || ''} onChange={(e) => updateDeductor(district, 'dpoName', e.target.value)} className="p-2 border rounded" placeholder="DPO Name" />
              <input value={info.dpoFatherName || ''} onChange={(e) => updateDeductor(district, 'dpoFatherName', e.target.value)} className="p-2 border rounded" placeholder="DPO Father Name" />
            </div>
            <button onClick={() => saveDeductor(district)} disabled={saving} className="flex items-center gap-2 bg-orange-500 text-white px-4 py-2 rounded-lg hover:bg-orange-600">
              <Save size={16} /> {saving ? 'Saving...' : 'Save'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
